import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { DevDocumentListPageFilterSchema } from './-zod-schema';

// 開発ドキュメント台帳 一覧（PN Force グローバルメニュー）。
// URL search のスキーマだけここで定義し、コンポーネントは index.lazy.tsx 側で
// createLazyFileRoute 経由で遅延ロードして bundle 分割する
// （development-tickets / test-sets / values と同じパターン：DataTable /
//   useReactTable の重い generic 推論を module 境界で trunk typecheck から分離）。
export const Route = createFileRoute('/_stacktrace/development-documents/')({
  validateSearch: zodValidator(DevDocumentListPageFilterSchema)
});